import React from "react"
const CommonDevelopmentJourney = ({ data }) => {
  const getImage = () => {
    if (data.mobileImages) {
      return (
        <div className="self-end min-w-[345px] md:min-w-[820px]  xl:min-w-[850px]  relative h-full flex gap-4 md:gap-6 xl:gap-8 items-center ">
          {data.mobileImages.map((image, index) => (
            <div key={"mobile-image" + (index + 1)}>
              <img
                src={image.url}
                alt={image.label}
                className=" w-[94px] md:w-full   "
                loading="lazy"
              />
            </div>
          ))}
          <div className="absolute rounded-s-[1rem] md:rounded-s-[3rem] ml-auto -z-10 w-[300px] md:w-[700px] xl:w-[720px] bottom-0   top-0 left-0 right-0  bg-primary-100"></div>
        </div>
      )
    }
    return (
      <div className="self-end min-w-[450px] md:min-w-[600px]  xl:min-w-[720px]  relative h-full flex items-center ">
        <div className="  w-[335px] md:w-[550px] xl:w-[650px]  ">
          <img
            src={data.webImage.url}
            alt={data.webImage.label}
            className="w-full  "
            loading="lazy"
          />
        </div>
        <div className="absolute rounded-s-[1rem] md:rounded-s-[3rem] ml-auto -z-10 w-[292px] md:w-[320px] xl:w-[439px] bottom-0   top-0 left-0 right-0  bg-primary-100"></div>
      </div>
    )
  }
  return (
    <div className="md:px-20 h-full md:pe-20 px-6 flex flex-col  ">
      <div className="items-center w-max  basis-full flex gap-32 md:gap-20 xl:gap-32 flex-row">
        <div className="flex w-[254px]  md:w-[480px] xl:w-[597px] flex-col gap-4 md:gap-10 ">
          <div className="flex flex-col items-start gap-4 w-full">
            {/* <div className="flex items-center gap-2">
              <div className="bg-blue-100 w-2 h-2 rounded-full"></div>
              <h4
                className={`text-gray-500 text-lg lg:text-2xl tracking-[-0.56px] md:tracking-tight-4% `}
              >
                Process
              </h4>
            </div> */}
            {/* <h2
              className={`text-gray-100 text-3xl md:text-5xl lg:text-8xl tracking-[-.96px] md:tracking-tight-2% lg:tracking-tight-7%`}
            >
              Development Journey
            </h2> */}
            <p
              className={`text-[1.08rem] md:text-[1.125rem] mt-0 md:mt-6 xl:mt-8 text-start text-black-300 `}
            >
              {data.description}
            </p>
          </div>
        </div>

        {getImage()}
      </div>
    </div>
  )
}

export default CommonDevelopmentJourney
